module.exports = __webpack_public_path__ + "img/red-downarrow.fc1853e1.svg";